module.exports = __webpack_public_path__ + "assets/img/859f-cz.svg";